import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    banco: '',
    moneda: '',
    cuentaNumero: '',
    fechaCierre: moment('1900-01-01').format('YYYY-MM-DD'),
    fechaCierreHabilitada: false,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_BANCO_CUENTA_CIERRE'(state, bancoCuentaId) {
        state.id = bancoCuentaId;
        state.banco = '';
        state.moneda = '';
        state.cuentaNumero = '';
        state.fechaCierre = moment('1900-01-01').format('YYYY-MM-DD');
        state.fechaCierreHabilitada = false;
        state.rowVersion = null;
    },
    'SET_BANCO_CUENTA_CIERRE'(state, bancoCuenta) {
        state.banco = bancoCuenta.banco;
        state.moneda = bancoCuenta.moneda;
        state.cuentaNumero = bancoCuenta.cuentaNumero;
        state.fechaCierre = moment(bancoCuenta.fechaCierre).format('YYYY-MM-DD');
        if (moment(bancoCuenta.fechaCierre).format('YYYY-MM-DD') != '1900-01-01') {
            state.fechaCierreHabilitada = true;
        } else {
            state.fechaCierreHabilitada = false;   
        }
        state.rowVersion = bancoCuenta.rowVersion;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, bancoCuentaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_CUENTA_CIERRE', bancoCuentaId);

            if (bancoCuentaId != 0) {
                apiAxios.get(`bancoscuentas/${bancoCuentaId}/cierre` ) 
                    .then(res => {
                        commit('SET_BANCO_CUENTA_CIERRE', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let fechaCierre = '1900-01-01';
            if ((/true/i).test(state.fechaCierreHabilitada)) {
                fechaCierre = moment(state.fechaCierre).format('YYYY-MM-DD');
            }

            let bancoCuentaCierre = {
                cuentaNumero: state.cuentaNumero.trim(),
                fechaCierre: fechaCierre,
                rowVersion: state.rowVersion,
            }

            apiAxios.post(`bancoscuentas/${state.id}/cierre`, bancoCuentaCierre)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}